export class ForgetPassword
{
    email: string;
    clientURI: string;    
}